<template>
  <div class="row p-0 m-0 home-background" >
      <div class="col-md-8" style="padding:100px 0px 0px 100px ">
          <div>
            <p class="name-title1" style="font-weight:700">Hi, Looking for a developer !</p>
            <p class="name-title">I am Asanka madhushan gamage.</p>
            <p class="name-title1" style="font-size: 20px">An undergraduate at SLIIT campus Malabe...</p>
          </div>

            <div class="wrapper_second">
                <!-- <div class="static-txt">I'm a</div> -->
                <ul class="dynamic-txts">
                  <li><span>Mobile app Developer</span></li>
                  <li><span>Designer</span></li>
                  <li><span>Web application Developer</span></li>
                  <li><span>Software Developer</span></li>
                </ul>
            </div>

          <div>
              <!-- <button class="btn btn-primary-marron">Download CV</button> -->
              <a href="" class="btn btn-primary-marron"><i class="fas fa-file-download"></i><span class="mx-3">Download CV</span></a>
 <!-- https://drive.google.com/u/2/uc?id=1HHJASqVvBMLVaec1tDqVUU3wK7B4vbqL&export=download -->
                <!-- <b-button variant="primary" class="btn-primary-marron">Download CV  <b-icon icon="cloud-download" aria-hidden="true"></b-icon></b-button> -->

           </div>
      </div>
      
      <div class="col-md-4"></div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.btn-primary-marron {
    background:#AF1B3F;
    transition:.2s;
    font-weight:bold;
    color: white;
    position: absolute;
    margin-top:50px;
    
 }

.btn-primary-marron:hover {
    background:#27010b;
    color: #ffff;
}

.home-background {
    position: relative;
    background: #C4C4C477;
    height: 91.5%;
    z-index: 1000;
}

.name-title {
    color:#AF1B3F;
    font-size:48px;
    font-family: 'Roboto', sans-serif;
    font-weight:700;
 }

.name-title1 {
    color:#000;
    font-size:24px;
    font-family: 'Roboto', sans-serif;
    line-height: 0px;
  }

  /*animation */

  .wrapper_second{
  /* display: flex; */
  margin-left:-30px;
  margin-top:40px;
 
}
/* .wrapper .static-txt{
  color: #fff;
  font-size: 30px;
  font-weight: 400;
} */
.wrapper_second .dynamic-txts{
  margin-left:0px;
  height: 90px;
  line-height: 90px;
  overflow: hidden;
}

.dynamic-txts li{
  list-style: none;
  color: #473144;
  font-size: 25px;
  font-family: 'Inconsolata', monospace;
  font-weight: 500;
  position: relative;
  top: 0;
  animation: slide 12s steps(4) infinite;
}

@keyframes slide {
  100%{
    top: -360px;
  }
}
.dynamic-txts li span{
  position: relative;
  margin: 5px 0;
  line-height: 90px;
}

@keyframes typing {
  40%, 60%{
    left: calc(100% + 30px);
  }
  100%{
    left: 0;
  }
}
  </style>